// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftList[data-v-20547530]{height:100%;width:16.667vw!important;overflow:auto;padding:1.042vw 0}.left-list[data-v-20547530]{margin-bottom:1.042vw;width:15.625vw}.left-list .left-row[data-v-20547530]{padding:.521vw 1.042vw;line-height:1.25vw;border:1px solid #e1e1e1}.left-list .left-row[data-v-20547530]:nth-child(n+2){border-top:none}.left-list .left-row .sp1[data-v-20547530]{display:inline-block;width:45%;font-size:.833vw}", ""]);
// Exports
module.exports = exports;
